import React, { useState, useEffect } from 'react'
import { useParams, useNavigate, Outlet } from 'react-router-dom'

import { useRanking } from 'data/hooks/use-ranking'
import { EventsMenu } from 'basecomps'

export const RankingEvents = props => {

  // valores por defecto
  const gameId = useParams().gameId || playmotiv.game.gameId
  const { eventId } = useParams()
  const rankingId = (props?.attribs || {})["data-rankingid"] ||
                    useParams().rankingId ||
                    props.rankingId

  const { events } = useRanking(gameId, rankingId)
  const navigate = useNavigate()
  
  useEffect(() => {

    if (events.length > 0 && eventId === undefined) {
      // TODO: en lugar de ir directamente al primero, debería ir al "actual"
      // navigate(`/game/${props.type || 'events'}/${eventType}/${events[0].eventId}`)
      // console.log(`auto navigate to ${events[0].eventId}`)
      navigate(`./${events[0].eventId}`)
    }

  }, [events])

  return (
    <div 
      className={`
        rankings
        ${ events.length > 1 ? 'with-menu' : '' }
      `}
    >
      { events.length > 1 && <div className="events-menu"><EventsMenu events={events} {...props} /></div> }
      { events.length === 0 ?
          <div>En estos momentos no hay ningún evento que disponga de este ranking</div>
        :
          <div className="rankings-wrapper">
            { !eventId ? 
              <>Selecciona un evento para ver su ranking</>
              :
              <Outlet />
            }
          </div>
      }
    </div>
  )
}
